'use client';

import React, { memo, useMemo, useState, Suspense, lazy } from 'react';
import styles from './Tabs.module.css';

export type TabItem = {
  key: string;
  label: string;
  content: React.ReactNode;
};

// Wrapper component to only render active tab content
const TabContent = memo(({ content }: { content: React.ReactNode }) => {
  return <>{content}</>;
});

export const Tabs = memo(function Tabs({ items, defaultKey }: { items: TabItem[]; defaultKey?: string }) {
  const initial = useMemo(() => {
    if (defaultKey && items.some((i) => i.key === defaultKey)) return defaultKey;
    return (items[0] && items[0].key) || '';
  }, [defaultKey, items]);

  const [active, setActive] = useState<string>(initial);
  const activeItem = useMemo(() => items.find((i) => i.key === active) || items[0], [items, active]);

  return (
    <div>
      <div className={styles.tabs} role="tablist" aria-label="Ürün içeriği sekmeleri">
        {items.map((it) => (
          <button
            key={it.key}
            className={`${styles.tab} ${it.key === active ? styles.active : ''}`}
            onClick={() => setActive(it.key)}
            type="button"
            role="tab"
            aria-selected={it.key === active}
          >
            {it.label}
          </button>
        ))}
      </div>
      <div className={styles.panel} role="tabpanel">
        <Suspense fallback={<div style={{padding: '20px', textAlign: 'center'}}>Yükleniyor...</div>}>
          {activeItem && <TabContent content={activeItem.content} />}
        </Suspense>
      </div>
    </div>
  );
});




